import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly fullscreen = signal(false);

  setFullscreen(value: boolean): void {
    this.fullscreen.set(value);
  }

  toggleFullscreen(): void {
    this.fullscreen.update(v => !v);
  }
}
